/**
 * The required format for a boolean flag key.
 */
/**
 * Helper function to test that enum keys and values match correct format.
 *
 * It is not possible as of Typescript 5.2 to declare a type for an enum key or value in-line.
 * Therefore, we must test the enum via a helper function that abstracts the enum to an object.
 *
 * If the test fails, you should review your `enum` to verify that both the
 * keys and values match the format specified by the `FlagKey` template literal type.
 * ref: https://stackoverflow.com/a/58181315
 *
 * @param testEnum - the Enum to type check
 */
export function testFlagEnumValidity(_) { }
export var FeatureFlagsKeysEnum;
(function (FeatureFlagsKeysEnum) {
    // Boolean flags
    FeatureFlagsKeysEnum["IS_API_IDEMPOTENCY_ENABLED"] = "IS_API_IDEMPOTENCY_ENABLED";
    FeatureFlagsKeysEnum["IS_API_RATE_LIMITING_DRY_RUN_ENABLED"] = "IS_API_RATE_LIMITING_DRY_RUN_ENABLED";
    FeatureFlagsKeysEnum["IS_API_RATE_LIMITING_KEYLESS_DRY_RUN_ENABLED"] = "IS_API_RATE_LIMITING_KEYLESS_DRY_RUN_ENABLED";
    FeatureFlagsKeysEnum["IS_API_RATE_LIMITING_ENABLED"] = "IS_API_RATE_LIMITING_ENABLED";
    FeatureFlagsKeysEnum["IS_CLOUDFLARE_SOCKETS_ENABLED"] = "IS_CLOUDFLARE_SOCKETS_ENABLED";
    FeatureFlagsKeysEnum["IS_LEGACY_WS_SERVICE_DISABLED"] = "IS_LEGACY_WS_SERVICE_DISABLED";
    FeatureFlagsKeysEnum["IS_EMAIL_INLINE_CSS_DISABLED"] = "IS_EMAIL_INLINE_CSS_DISABLED";
    FeatureFlagsKeysEnum["IS_EVENT_QUOTA_THROTTLER_ENABLED"] = "IS_EVENT_QUOTA_THROTTLER_ENABLED";
    FeatureFlagsKeysEnum["IS_NEW_MESSAGES_API_RESPONSE_ENABLED"] = "IS_NEW_MESSAGES_API_RESPONSE_ENABLED";
    FeatureFlagsKeysEnum["IS_USAGE_ALERTS_ENABLED"] = "IS_USAGE_ALERTS_ENABLED";
    FeatureFlagsKeysEnum["IS_USE_MERGED_DIGEST_ID_ENABLED"] = "IS_USE_MERGED_DIGEST_ID_ENABLED";
    FeatureFlagsKeysEnum["IS_V2_ENABLED"] = "IS_V2_ENABLED";
    FeatureFlagsKeysEnum["IS_WORKFLOW_NODE_PREVIEW_ENABLED"] = "IS_WORKFLOW_NODE_PREVIEW_ENABLED";
    FeatureFlagsKeysEnum["IS_WEBHOOKS_MANAGEMENT_ENABLED"] = "IS_WEBHOOKS_MANAGEMENT_ENABLED";
    FeatureFlagsKeysEnum["IS_KEYLESS_ENVIRONMENT_CREATION_ENABLED"] = "IS_KEYLESS_ENVIRONMENT_CREATION_ENABLED";
    /** When enabled, API-key auth on GET /v1/environments returns decrypted apiKeys for every environment in the org (pre-NV-7641 opt-in behavior). */
    FeatureFlagsKeysEnum["IS_LIST_ENVIRONMENTS_API_KEYS_ENABLED"] = "IS_LIST_ENVIRONMENTS_API_KEYS_ENABLED";
    FeatureFlagsKeysEnum["IS_TEST_PROVIDER_LIMITS_ENABLED"] = "IS_TEST_PROVIDER_LIMITS_ENABLED";
    FeatureFlagsKeysEnum["IS_2025_Q1_LEGACY_TIERING_MIGRATION"] = "IS_2025_Q1_LEGACY_TIERING_MIGRATION";
    FeatureFlagsKeysEnum["IS_SUBSCRIBER_ID_VALIDATION_DRY_RUN_ENABLED"] = "IS_SUBSCRIBER_ID_VALIDATION_DRY_RUN_ENABLED";
    FeatureFlagsKeysEnum["IS_TOPIC_KEYS_VALIDATION_DRY_RUN_ENABLED"] = "IS_TOPIC_KEYS_VALIDATION_DRY_RUN_ENABLED";
    FeatureFlagsKeysEnum["IS_RBAC_ENABLED"] = "IS_RBAC_ENABLED";
    FeatureFlagsKeysEnum["IS_HTTP_LOGS_PAGE_ENABLED"] = "IS_HTTP_LOGS_PAGE_ENABLED";
    FeatureFlagsKeysEnum["IS_TRACE_LOGS_ENABLED"] = "IS_TRACE_LOGS_ENABLED";
    FeatureFlagsKeysEnum["IS_TRACE_LOGS_READ_ENABLED"] = "IS_TRACE_LOGS_READ_ENABLED";
    FeatureFlagsKeysEnum["IS_INBOUND_WEBHOOKS_ENABLED"] = "IS_INBOUND_WEBHOOKS_ENABLED";
    FeatureFlagsKeysEnum["IS_INBOUND_WEBHOOKS_CONFIGURATION_ENABLED"] = "IS_INBOUND_WEBHOOKS_CONFIGURATION_ENABLED";
    FeatureFlagsKeysEnum["IS_STEP_RUN_LOGS_READ_ENABLED"] = "IS_STEP_RUN_LOGS_READ_ENABLED";
    FeatureFlagsKeysEnum["IS_STEP_RUN_LOGS_WRITE_ENABLED"] = "IS_STEP_RUN_LOGS_WRITE_ENABLED";
    FeatureFlagsKeysEnum["IS_WORKFLOW_RUN_LOGS_WRITE_ENABLED"] = "IS_WORKFLOW_RUN_LOGS_WRITE_ENABLED";
    FeatureFlagsKeysEnum["IS_WORKFLOW_RUN_LOGS_READ_ENABLED"] = "IS_WORKFLOW_RUN_LOGS_READ_ENABLED";
    FeatureFlagsKeysEnum["IS_WORKFLOW_RUN_TRACES_WRITE_ENABLED"] = "IS_WORKFLOW_RUN_TRACES_WRITE_ENABLED";
    FeatureFlagsKeysEnum["IS_WORKFLOW_RUN_PAGE_MIGRATION_ENABLED"] = "IS_WORKFLOW_RUN_PAGE_MIGRATION_ENABLED";
    FeatureFlagsKeysEnum["IS_WORKFLOW_RUN_COUNT_ENABLED"] = "IS_WORKFLOW_RUN_COUNT_ENABLED";
    FeatureFlagsKeysEnum["IS_DELIVERY_LIFECYCLE_TRANSITION_ENABLED"] = "IS_DELIVERY_LIFECYCLE_TRANSITION_ENABLED";
    FeatureFlagsKeysEnum["IS_EXECUTION_DETAILS_CLICKHOUSE_ONLY_ENABLED"] = "IS_EXECUTION_DETAILS_CLICKHOUSE_ONLY_ENABLED";
    FeatureFlagsKeysEnum["IS_GET_PREFERENCES_DISABLED"] = "IS_GET_PREFERENCES_DISABLED";
    FeatureFlagsKeysEnum["IS_REGION_SELECTOR_ENABLED"] = "IS_REGION_SELECTOR_ENABLED";
    FeatureFlagsKeysEnum["IS_PUSH_UNREAD_COUNT_ENABLED"] = "IS_PUSH_UNREAD_COUNT_ENABLED";
    FeatureFlagsKeysEnum["IS_EXPIRED_TOKENS_REMOVAL_ENABLED"] = "IS_EXPIRED_TOKENS_REMOVAL_ENABLED";
    FeatureFlagsKeysEnum["IS_ANALYTICS_WORKFLOW_FILTER_ENABLED"] = "IS_ANALYTICS_WORKFLOW_FILTER_ENABLED";
    FeatureFlagsKeysEnum["IS_CONTEXTUAL_HELP_DRAWER_ENABLED"] = "IS_CONTEXTUAL_HELP_DRAWER_ENABLED";
    FeatureFlagsKeysEnum["IS_SUBSCRIPTION_PREFERENCES_ENABLED"] = "IS_SUBSCRIPTION_PREFERENCES_ENABLED";
    FeatureFlagsKeysEnum["IS_LRU_CACHE_ENABLED"] = "IS_LRU_CACHE_ENABLED";
    FeatureFlagsKeysEnum["IS_CONTEXT_PREFERENCES_ENABLED"] = "IS_CONTEXT_PREFERENCES_ENABLED";
    FeatureFlagsKeysEnum["IS_PREFERENCE_FETCH_OPTIMIZATION_ENABLED"] = "IS_PREFERENCE_FETCH_OPTIMIZATION_ENABLED";
    FeatureFlagsKeysEnum["IS_BILLING_USAGE_CLICKHOUSE_ENABLED"] = "IS_BILLING_USAGE_CLICKHOUSE_ENABLED";
    FeatureFlagsKeysEnum["IS_BILLING_USAGE_CLICKHOUSE_SHADOW_ENABLED"] = "IS_BILLING_USAGE_CLICKHOUSE_SHADOW_ENABLED";
    FeatureFlagsKeysEnum["IS_BILLING_USAGE_DETAILED_DIAGNOSTICS_ENABLED"] = "IS_BILLING_USAGE_DETAILED_DIAGNOSTICS_ENABLED";
    FeatureFlagsKeysEnum["IS_AI_WORKFLOW_GENERATION_ENABLED"] = "IS_AI_WORKFLOW_GENERATION_ENABLED";
    /** Enable the Novu Wizard LLM Gateway (`POST /v2/llm/messages`) for an organization. Enterprise-only. */
    FeatureFlagsKeysEnum["IS_LLM_GATEWAY_ENABLED"] = "IS_LLM_GATEWAY_ENABLED";
    FeatureFlagsKeysEnum["IS_CLICKHOUSE_BATCHING_ENABLED"] = "IS_CLICKHOUSE_BATCHING_ENABLED";
    FeatureFlagsKeysEnum["IS_ORG_KILLSWITCH_FLAG_ENABLED"] = "IS_ORG_KILLSWITCH_FLAG_ENABLED";
    FeatureFlagsKeysEnum["IS_USAGE_REPORT_ENABLED"] = "IS_USAGE_REPORT_ENABLED";
    FeatureFlagsKeysEnum["IS_USAGE_REPORT_DELAY_ENABLED"] = "IS_USAGE_REPORT_DELAY_ENABLED";
    FeatureFlagsKeysEnum["IS_STEP_RESOLVER_ENABLED"] = "IS_STEP_RESOLVER_ENABLED";
    FeatureFlagsKeysEnum["IS_ACTION_STEP_RESOLVER_ENABLED"] = "IS_ACTION_STEP_RESOLVER_ENABLED";
    /** Enable conversational Agents UI in the dashboard; create the boolean in LaunchDarkly for cloud, or set `VITE_IS_CONVERSATIONAL_AGENTS_ENABLED` when self-hosted. */
    FeatureFlagsKeysEnum["IS_CONVERSATIONAL_AGENTS_ENABLED"] = "IS_CONVERSATIONAL_AGENTS_ENABLED";
    /** Enable managed-runtime mode for Agents (e.g. Claude Platform). Create the boolean in LaunchDarkly for cloud, or set `VITE_IS_MANAGED_AGENT_RUNTIME_ENABLED` when self-hosted. */
    FeatureFlagsKeysEnum["IS_MANAGED_AGENT_RUNTIME_ENABLED"] = "IS_MANAGED_AGENT_RUNTIME_ENABLED";
    /** Enable Novu-managed demo Claude provider auto-provisioned on dev environments. Create the boolean in LaunchDarkly for cloud, or set `VITE_IS_DEMO_MANAGED_CLAUDE_ENABLED` when self-hosted. */
    FeatureFlagsKeysEnum["IS_DEMO_MANAGED_CLAUDE_ENABLED"] = "IS_DEMO_MANAGED_CLAUDE_ENABLED";
    /** Enable Microsoft Teams Quick Setup in the dashboard; create the boolean in LaunchDarkly for cloud, or set `VITE_IS_MSTEAMS_QUICK_SETUP_ENABLED` when self-hosted. */
    FeatureFlagsKeysEnum["IS_MSTEAMS_QUICK_SETUP_ENABLED"] = "IS_MSTEAMS_QUICK_SETUP_ENABLED";
    /** Enable Slack Quick Setup in the dashboard; create the boolean in LaunchDarkly for cloud, or set `VITE_IS_SLACK_QUICK_SETUP_ENABLED` when self-hosted. */
    FeatureFlagsKeysEnum["IS_SLACK_QUICK_SETUP_ENABLED"] = "IS_SLACK_QUICK_SETUP_ENABLED";
    /** Enable the Domains management page in the dashboard. */
    FeatureFlagsKeysEnum["IS_DOMAINS_PAGE_ENABLED"] = "IS_DOMAINS_PAGE_ENABLED";
    /** Enable Domain Connect auto-configuration for inbound email domains. */
    FeatureFlagsKeysEnum["IS_DOMAIN_CONNECT_INBOUND_EMAIL_ENABLED"] = "IS_DOMAIN_CONNECT_INBOUND_EMAIL_ENABLED";
    /** Enable the new app-rail dashboard shell with the Connect app surface. */
    FeatureFlagsKeysEnum["IS_CONNECT_DASHBOARD_ENABLED"] = "IS_CONNECT_DASHBOARD_ENABLED";
    /**
     * Enable MCP connections that use Novu's pre-registered OAuth app
     * (`auth mode = 'novu-app'`). Gates both `EnableAgentMcpServer` for any
     * catalog entry whose `oauth.mode === 'novu-app'` and `GenerateMcpOAuthUrl`
     * when it resolves to the novu-app branch. DCR connections are never gated
     * by this flag.
     */
    FeatureFlagsKeysEnum["IS_MCP_NOVU_APP_ENABLED"] = "IS_MCP_NOVU_APP_ENABLED";
    /**
     * Enable MCP connections where OAuth is fully delegated to the managed
     * agent runtime provider (`auth mode = 'provider-managed'`). Gates the
     * "Add from Claude" flow in the dashboard and the
     * `POST .../mcp-servers/:mcpId/provider-vault` endpoint. When off,
     * provider-managed catalog rows still appear in the picker but the Add
     * button is disabled.
     */
    FeatureFlagsKeysEnum["IS_MCP_PROVIDER_MANAGED_ENABLED"] = "IS_MCP_PROVIDER_MANAGED_ENABLED";
    // String flags
    FeatureFlagsKeysEnum["CF_SCHEDULER_MODE"] = "CF_SCHEDULER_MODE";
    FeatureFlagsKeysEnum["QUEUE_BACKEND_MODE"] = "QUEUE_BACKEND_MODE";
    FeatureFlagsKeysEnum["USAGE_REPORT_TRIGGER_SECRET"] = "USAGE_REPORT_TRIGGER_SECRET";
    FeatureFlagsKeysEnum["USAGE_REPORT_OVERRIDE_EMAIL"] = "USAGE_REPORT_OVERRIDE_EMAIL";
    // Numeric flags
    FeatureFlagsKeysEnum["MAX_WORKFLOW_LIMIT_NUMBER"] = "MAX_WORKFLOW_LIMIT_NUMBER";
    FeatureFlagsKeysEnum["MAX_LAYOUT_LIMIT_NUMBER"] = "MAX_LAYOUT_LIMIT_NUMBER";
    FeatureFlagsKeysEnum["MAX_STEPS_PER_WORKFLOW_LIMIT_NUMBER"] = "MAX_STEPS_PER_WORKFLOW_LIMIT_NUMBER";
    FeatureFlagsKeysEnum["MAX_DEFER_DURATION_IN_MS_NUMBER"] = "MAX_DEFER_DURATION_IN_MS_NUMBER";
    FeatureFlagsKeysEnum["MAX_THROTTLE_WINDOW_DURATION_IN_MS_NUMBER"] = "MAX_THROTTLE_WINDOW_DURATION_IN_MS_NUMBER";
    FeatureFlagsKeysEnum["LOG_EXPIRATION_DAYS_NUMBER"] = "LOG_EXPIRATION_DAYS_NUMBER";
    FeatureFlagsKeysEnum["MAX_DATE_ANALYTICS_ENABLED_NUMBER"] = "MAX_DATE_ANALYTICS_ENABLED_NUMBER";
    FeatureFlagsKeysEnum["MAX_ENVIRONMENT_COUNT"] = "MAX_ENVIRONMENT_COUNT";
    FeatureFlagsKeysEnum["MAX_SUBSCRIBER_DEVICE_TOKENS_NUMBER"] = "MAX_SUBSCRIBER_DEVICE_TOKENS_NUMBER";
    FeatureFlagsKeysEnum["MAX_ENVIRONMENT_VARIABLES_LIMIT_NUMBER"] = "MAX_ENVIRONMENT_VARIABLES_LIMIT_NUMBER";
    FeatureFlagsKeysEnum["MAX_STEP_RESOLVERS_NUMBER"] = "MAX_STEP_RESOLVERS_NUMBER";
    FeatureFlagsKeysEnum["MAX_DOMAINS_LIMIT_NUMBER"] = "MAX_DOMAINS_LIMIT_NUMBER";
    FeatureFlagsKeysEnum["MAX_CONNECT_ORG_AUTO_PROVISIONED_SUBSCRIBERS_NUMBER"] = "MAX_CONNECT_ORG_AUTO_PROVISIONED_SUBSCRIBERS_NUMBER";
    FeatureFlagsKeysEnum["IS_ANALYTICS_PAGE_ENABLED"] = "IS_ANALYTICS_PAGE_ENABLED";
    FeatureFlagsKeysEnum["IS_LEGACY_SELECTOR_BUTTON_VISIBLE"] = "IS_LEGACY_SELECTOR_BUTTON_VISIBLE";
})(FeatureFlagsKeysEnum || (FeatureFlagsKeysEnum = {}));
export var CloudflareSchedulerMode;
(function (CloudflareSchedulerMode) {
    CloudflareSchedulerMode["OFF"] = "off";
    CloudflareSchedulerMode["SHADOW"] = "shadow";
    CloudflareSchedulerMode["LIVE"] = "live";
    CloudflareSchedulerMode["COMPLETE"] = "complete";
})(CloudflareSchedulerMode || (CloudflareSchedulerMode = {}));
export var QueueBackendMode;
(function (QueueBackendMode) {
    QueueBackendMode["BULLMQ"] = "bullmq";
    QueueBackendMode["SHADOW"] = "shadow";
    QueueBackendMode["LIVE"] = "live";
    QueueBackendMode["COMPLETE"] = "complete";
})(QueueBackendMode || (QueueBackendMode = {}));
//# sourceMappingURL=feature-flags.js.map